import * as translations from './translations'

export function togglePassword(target) {
    const targets = document.querySelectorAll(target)
    targets.forEach(item => {

        item.addEventListener('click', () => {
            item.classList.toggle('active')
            if (item.classList.contains('active')) {
                item.nextElementSibling.setAttribute('type', 'text');
                item.innerHTML = translations.translations[translations.lang]['password_toggle_of'];
            } else {
                item.nextElementSibling.setAttribute('type', 'password');
                item.innerHTML = translations.translations[translations.lang]['password_toggle'];
            }
        })
    })


}